const validate = {
    length: {
        MIN_LENGTH_TITLE: 1,
        MAX_LENGTH_TITLE: 50,
        MIN_LENGTH_CONTENT: 1,
        MAX_LENGTH_CONTENT: 1000,
    }
};

export default validate;
